module.exports = __webpack_public_path__ + "img/5.dcba4e5d.png";